<template>
	<div class="container addorder">
    <div class="cart_pro_list super" v-if="superinfo.supername">
      <p class="f16">归属店铺</p>
      <div class="store">
        <p class="f14">专属顾问</p>
        <span class="f14">真实姓名：{{superinfo.supername}}</span>
      </div>
    </div>
    <div v-if="addressVal.area" class="my_address" @click="address">
      <img src="../../assets/images/addressicon.png" class="addressicon"/>
      <div class="addressML">
        <div class="my_main_address">
          <span>{{addressVal.name}}   {{addressVal.mobile}}</span>
          <img v-if="addressVal.isdefault === '1'" src="../../assets/images/default.png">
        </div>
        <div class="address">{{addressVal.area + '' + addressVal.address}}</div>
      </div>
      <van-icon name="arrow" />
    </div>
    <div v-if="!addressVal.area" class="no_address" @click="addaddress">
      <van-icon name="plus" />
      <p>添加收货地址</p>
    </div>
    <div class="cart_pro_list">
      <div class="list">
        <pro-item v-for="(item, index) of list" :key="index" :productItem="item"></pro-item>
      </div>
      <div class="numtotal">
        <van-button type="primary" size="mini" round plain color="#FB6E38" @click="goVipGiftList">&nbsp;&nbsp;更换礼包&nbsp;&nbsp;</van-button>
      </div>
    </div>
    <div class="h footerIOS"></div>
    <div class="sub_bar footerIOS">
      <div class="itemtxt">礼包总额:
        <span class="xprice" v-if="shopConfirmResult.totalmoney">
          <sub>¥</sub>
          <b>{{!isNaN(shopConfirmResult.totalmoney) ? String(shopConfirmResult.totalmoney).slice(0, String(shopConfirmResult.totalmoney).indexOf('.')) : '0'}}</b>
          <sup>{{!isNaN(shopConfirmResult.totalmoney)? String(shopConfirmResult.totalmoney).slice(String(shopConfirmResult.totalmoney).indexOf('.'), String(shopConfirmResult.totalmoney).length) : '.00'}}</sup>
        </span>
        需支付:
        <span class="xprice" v-if="shopConfirmResult.paymoney">
          <sub>¥</sub>
          <b>{{!isNaN(shopConfirmResult.paymoney) ? String(shopConfirmResult.paymoney).slice(0, String(shopConfirmResult.paymoney).indexOf('.')) : '0'}}</b>
          <sup>{{!isNaN(shopConfirmResult.paymoney)? String(shopConfirmResult.paymoney).slice(String(shopConfirmResult.paymoney).indexOf('.'), String(shopConfirmResult.paymoney).length) : '.00'}}</sup>
        </span>
      </div>
      <div class="btton" @click="goNext">提交订单</div>
    </div>
  </div>
</template>

<script>
import proItem from '../common/cart_pro_item'
import wx from "weixin-js-sdk";
import { appid, isWeixin, fenxiang } from '../../assets/common/js/config'
export default {
  name: "vipgiftbagaddOrder",
  components: {
    proItem
  },
  data () {
    return {
      addressVal: {},
      list: [],
      superinfo: {},
      shopConfirmResult: {},
      ckdlbid: ''
    }
  },
  mounted () {
	if (isWeixin()) {
	  fenxiang({path: 'vipgiftbagaddOrder'})
	}
    if (sessionStorage.getItem('shopConfirmResult_vipgift')) this.shopConfirmResult = JSON.parse(sessionStorage.getItem('shopConfirmResult_vipgift'))
    if (sessionStorage.getItem('shopConfirmProduct_vipgift')) this.list = JSON.parse(sessionStorage.getItem('shopConfirmProduct_vipgift'))
    if (sessionStorage.getItem('superinfo')) this.superinfo = JSON.parse(sessionStorage.getItem('superinfo'))
    this.getData()
  },
  methods: {
    getData () {
      var urlAddress1 = 'Wxmall/Address/getAddressById?id=' + this.$route.query.addressid
      var urlAddress2 = 'Wxmall/Address/getDefaultAddress'
      if (this.$route.query.addressid) {
        this.$customRequestAjax(urlAddress1).then((res) => {
          if (res.data.code === 200) {
            this.addressVal = res.data.addressdata
          }
        })
      } else {
        this.$customRequestAjax(urlAddress2).then((res) => {
          if (res.data.code === 200) {
            this.addressVal = res.data.addressdata
          }
        })
      }
    },
    address: function () {
      var query = this.$route.query
      query.addressid = this.addressVal.id
      query.type = 'vipgiftbagsubmitorder'
      this.$router.push({
        path: '/addresschoose',
        query: query
      })
    },
    addaddress: function () {
      var query = this.$route.query
      query.type = 'addorder'
      query.ordertype = 'vipgiftbagsubmitorder'
      this.$router.push({
        path: '/addadd',
        query: query
      })
    },
    goVipGiftList: function () {
      this.$router.replace({
        path: '/vipgiftbaglist'
      })
    },
    startSite(fn) {
      if (!isWeixin()) {
        this.$toast('请在微信使用此功能')
      }
      let that = this;
      wx.getLocation({
        type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: function(res) {
          that.latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
          that.longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
          // var speed = res.speed; // 速度，以米/每秒计
          // var accuracy = res.accuracy; // 位置精度
          if (typeof fn == 'function') fn(res.latitude, res.longitude)
        }
      });
    },
    goNext: function () {
      this.startSite((lat, lng) => {
        var that = this, url = 'Wxmall/VipGift/submitRegistOrder', data = {
          skuids: this.shopConfirmResult.skuidArr.join(),
          addressid: this.addressVal.id,
          buynum: this.shopConfirmResult.itemNum.join(),
          user_longitude: lng,
          user_latitude: lat
        }
        this.$customRequestAjax.post(url, data).then(res => {
          if (res.data.code == 200) {
            that.ckdlbid = res.data.ckdlbid
            var url = 'Wxmall/Sysinfo/getPayInfo'
            this.$customRequestAjax(url).then(function (res) {
              if (res.data.code === 200) {
                that.isSwitch = res.data
                that.$toast({
                  message: '提交成功',
                  icon: require('../../assets/images/succ.png')
                })
                if (isWeixin()) {
                  if (res.data.web_swiftwxpay == 1 || res.data.web_wxpay == 1) {
                    that.to_cash()
                  }
                }
              }
            })
          }
        })
      })
    },
    /*
     * 微信支付
     */
    to_cash: function () {
	    var phpUrl, that = this
	    if (that.isSwitch.web_wxpay == '1' && that.isSwitch.web_swiftwxpay == '1') {
		    phpUrl = '/pay/wxmall_pay/weixin/example/wxpay2.php'
        if (that.isSwitch.wx_paytype == 1) {
          phpUrl = '/pay/wxmall_pay/weixinnet/example/wxpay2.php'
        }
	    } else if (that.isSwitch.web_wxpay == '1') {
		    phpUrl = '/pay/wxmall_pay/weixin/example/wxpay2.php'
        if (that.isSwitch.wx_paytype == 1) {
          phpUrl = '/pay/wxmall_pay/weixinnet/example/wxpay2.php'
        }
	    } else if (that.isSwitch.web_swiftwxpay == '1') {
		    phpUrl = '/pay/swiftpass_pay/app.php'
	    }
	    var phpData = {
		    openid: appid,
		    ckdlbid: that.ckdlbid
	    }
	    that.$customRequestAjax.post(phpUrl, phpData).then(function (res) {
		    if (res.data && res.data.code == 200) {
			    that.$toast.clear()
			    if (that.isSwitch.web_wxpay == '1' && that.isSwitch.web_swiftwxpay == '1') {
				    that.callpay(JSON.parse(res.data.jsApiParameters))
			    } else if (that.isSwitch.web_wxpay == '1') {
				    that.callpay(JSON.parse(res.data.jsApiParameters))
			    } else if (that.isSwitch.web_swiftwxpay == '1') {
				    that.callpay(JSON.parse(res.data.codeinfo))
			    }
		    } else {
			    that.$toast(res.data.codeinfo)
		    }
	    })
    },
    /*
     * 微信支付调用
     */
    callpay: function (d) {
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', this.jsApiCall, false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.jsApiCall)
          document.attachEvent('onWeixinJSBridgeReady', this.jsApiCall)
        }
      } else {
        this.jsApiCall(d)
      }
    },
    /*
     * 调用微信JS api 支付
     */
    jsApiCall: function (d) {
      var that = this
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        d,
        function (res) {
          WeixinJSBridge.log(res.err_msg)
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            setTimeout(function () {
              that.$router.replace({
                path: '/vipgiftbagpayresult',
                query: {
                  ckdlbid: that.ckdlbid,
                  money: !isNaN(parseFloat(that.shopConfirmResult.paymoney)) ? that.shopConfirmResult.paymoney : 0,
                  payresult: encodeURIComponent('success')
                }
              })
            }, 1000)
          }
        }
      )
    }
  }
}
</script>

<style scoped lang="scss">
  .container {
    .my_address {
      margin: .11rem;
      background: #fff;
      border-radius: .04rem;
      padding:.15rem 0;
      padding-left: .15rem;
      position: relative;
      display: flex;
      align-items: center;
      .my_main_address {
        font-size: .16rem;
        line-height: .22rem;
        color: #222222;
        font-weight: 600;
        display: flex;
        display: -webkit-flex;
        display: -moz-flex;
        display: -o-flex;
        display: -ms-flex;
        align-items: center;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;
        -o-align-items: center;
        img {
          width: 0.2rem;
          height: 0.12rem;
          margin-left: 0.05rem;
        }
      }
      .addressML{
        margin-left: .1rem;
      }
      .address{
        font-size: .12rem;
        line-height: .17rem;
        color:#999;
        margin-top: .04rem;
        padding-right: .3rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .van-icon-location-o{
        position: absolute;
        top:.35rem;
        left:.17rem;
        font-size: .19rem;
      }
      .addressicon{
        width:.18rem;
        height: .2rem;
        flex-shrink: 0;
        -webkit-flex-shrink: 0;
        -moz-flex-shrink: 0;
        -ms-flex-shrink: 0;
        -o-flex-shrink: 0;
      }
      .van-icon-arrow{
        position: absolute;
        top:.35rem;
        right:.15rem;
        font-size: .16rem;
        color:#1D1E1E;
      }
    }
    .no_address {
      padding: 0.13rem 0.15rem;
      background:rgba(255,255,255,1);
      border-radius:0.04rem;
      font-size: 0;
      margin: .11rem;
      .van-icon-plus {
        font-size:0.15rem;
        line-height:0.21rem;
        color:rgba(29,30,30,1);
        top:0.02rem;
      }
      p {
        display: inline-block;
        font-size:0.15rem;
        font-weight:400;
        color:rgba(29,30,30,1);
        line-height:0.21rem;
        margin-left: 0.08rem;
      }
    }
    .cart_pro_list {
      border-radius: .04rem;
      background: #fff;
      margin: .1rem .11rem;
      padding: .1rem .15rem 0;
      .list{
        padding-bottom: .2rem;
        font-size: .14rem;
        position: relative;
      }
      .list:after{
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        right: 0;
        bottom: 0;
        left: 0;
        border-bottom: 1px solid #D8D8D8;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
      }
      .numtotal{
        font-size: .12rem;
        padding: 0.1rem 0;
        text-align: right;
        color:#3D3D3D;
      }
      &.super {
        padding-bottom: 0.1rem;
        >p {
          color: #292929;
          background: url(/static/images/VIP/super.png) no-repeat left center;
          background-size: auto 100%;
          padding-left: 0.3rem;
        }
        .store {
          border-radius: 0.04rem;
          padding: 0.1rem 0.11rem;
          margin-top: 0.1rem;
          background: #F6F7FA;
          p {
            color: #343434;
            margin-bottom: 0.07rem;
          }
          span {
            display: block;
            color: #666666;
          }
        }
      }
    }
    .h {
      min-height: .49rem;
    }
    .sub_bar{
      position: fixed;
      bottom: 0;
      left:0;
      z-index: 2;
      width: 100%;
      height: .49rem;
      display: flex;
      align-items: center;
      font-size: .14rem;
      background: #fff;
      padding: 0.06rem .11rem 0;
      justify-content: space-between;
      background:rgba(255,255,255,0.9);
      box-shadow:0px 1px 0px 0px rgba(0,0,0,0.25);
      .itemtxt{
        font-size: .12rem;
        color: #292929;
        margin-bottom: 0.06rem;
        .xprice {
          font-size: 0;
          color: #FB6E38;
          /*line-height: .2rem;*/
        }
        b {
          font-size: .14rem;
          font-weight: 500;
        }
        sub {
          font-weight: normal;
          font-size: .10rem;
          vertical-align: baseline
        }
        sup {
          font-size: .10rem;
          vertical-align: baseline;
          font-weight: 500;
        }
      }
      .btton{
        background: linear-gradient(90deg, #FB6E38 0%, #FE9B4B 100%);
        border-radius:.19rem;
        font-size: .16rem;
        width: 31%;
        line-height: .38rem;
        /*padding: .07rem .16rem;*/
        text-align: center;
        color:#fff;
        margin-bottom: 0.06rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/upgradeVIP/vipgiftbagaddOrder.vue